import gql from 'graphql-tag';

export default gql`
  mutation expireProductDiscountPrice($input: ExpireItemPriceForBuyersInput!) {
    expireProductDiscountPrice(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
